import React from 'react';
import type { CommandServices } from '@wix/cli-command-contract';
import { PreviewCommand } from '../components/PreviewCommand/index.js';
import type { ProjectModel } from '../model.js';
import { log } from './logger.js';
import { executeCommand } from './execute-command.js';

export async function nonInteractivePreview(
  services: CommandServices,
  model: ProjectModel,
  options: { baseUrl?: string; label?: string }
) {
  const { baseUrl, label } = options;

  const result = await executeCommand<{
    previewId: string;
    previewUrl?: string;
  }>(services, model, (resolve) => (
    <PreviewCommand
      baseUrl={baseUrl}
      onPreviewCreated={resolve}
      environment="preview"
      label={label}
    />
  ));

  log(JSON.stringify(result, null, 2));
}
